import { render, staticRenderFns } from "./setRiskDialog.vue?vue&type=template&id=3bbfa341&scoped=true&"
import script from "./setRiskDialog.vue?vue&type=script&lang=js&"
export * from "./setRiskDialog.vue?vue&type=script&lang=js&"
import style0 from "./setRiskDialog.vue?vue&type=style&index=0&id=3bbfa341&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfa341",
  null
  
)

export default component.exports